// extracted by mini-css-extract-plugin
export var deleteModal = "_fx-0";